import styled, { ColorsTypes } from 'styled-components';

export const Mark = styled.span`
  display: inline-block;
  position: relative;
  border-width: 2px;
  border-style: solid;
  width: 20px;
  height: 20px;
  left: 0;
  border-radius: 50%;

  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-radius: 50%;
    opacity: 0;
    left: 50%;
    top: 50%;
    position: absolute;
    transition: all 110ms;
    transform: translate(-50%, -50%);
  }
`;

export const Input = styled.input`
  position: absolute;
  visibility: hidden;
  display: none;

  &:checked + ${Mark} {
    &::after {
      width: 10px;
      height: 10px;
      opacity: 1;
    }
  }
`;

export const Wrapper = styled.label(({ theme, color }) => {
  return `
  display: flex;
  cursor: pointer;

  ${Mark} {
    border-color: ${theme.colors[color as ColorsTypes]};

    &::after {
      background-color: ${theme.colors[color as ColorsTypes]};
    }
  }
`;
});
